import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-furniture 96",
  "use": "icon-furniture 96-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-furniture 96\"><path d=\"M810.666667 170.666667a64 64 0 0 1 64 64v490.666666a64 64 0 0 1-64 64h-64v64h-64v-64H362.666667v64h-64v-64h-64a64 64 0 0 1-64-64V234.666667a64 64 0 0 1 64-64h576z m-320 64H234.666667v490.666666h256V234.666667z m320 0H554.666667v490.666666h256V234.666667z m-362.666667 170.666666v134.250667h-64V405.333333h64z m213.333333 0v134.250667h-64V405.333333h64z\" p-id=\"11231\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol